import React from "react";
import SelectComponent from 'pu-react/components/SelectComponent';

const options = [
  { value: '6 mm', text: '6 mm' },
  { value: '8 mm', text: '8mm' },
  { value: '12 mm', text: '12 mm' },
];

const tooltip = null

const MaterialThickness = (props) => {
  const name = 'carrier_thickness';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={name}
      onChange={props.onChange || onChange}
      options={props.options}
      tooltip={props.tooltip || tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName}
      className={props.className} />
  )
};

MaterialThickness.defaultProps =  {
  options,
  label: 'Material Thickness',
  required: true,
  className: 'carrier-thickness',
}
export default MaterialThickness;
